module.exports = __webpack_public_path__ + "static/media/ge.c9a85b6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ge.svg
// module id = 124
// module chunks = 0